import { render } from "./AYPScoreDisplay.vue?vue&type=template&id=308e01ca"
import script from "./AYPScoreDisplay.vue?vue&type=script&lang=js"
export * from "./AYPScoreDisplay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__